import zen2han from '../../lib/zen_to_han';

$(() => {
  if ($('.js-map-container').length === 0) {
    return;
  }

  let map = null;

  // 緯度経度のForm反映処理
  function refreshLatLng(m) {
    const pos = new google.maps.LatLng(m.getCenter().lat(), m.getCenter().lng());
    $('.js-lat').val(pos.lat()).change();
    $('.js-lng').val(pos.lng()).change();
  }

  // 地図の初期化処理
  function initializeMap() {
    const lat = $('.js-lat').val() || 35.694078;
    const lng = $('.js-lng').val() || 139.699533;

    const latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

    // マップ生成
    let zoom = 17;
    if ($('.js-map-container').find('.js-zoom').length !== 0) {
      zoom = $('.js-map-container').find('.js-zoom').val();
    }

    map = new google.maps.Map($('.js-map-container')[0], {
      zoom,
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: true,
      scrollwheel: false,
    });

    // マーカー
    let marker = new google.maps.Marker({
      map,
      position: map.getCenter(),
      draggable: false,
    });

    // 追加のマーカー
    if ($('.js-map-container').data('cursors')) {
      $($('.js-map-container').data('cursors')).each((_, cursor) => {
        marker = new google.maps.Marker({
          map,
          position: { lat: parseFloat(cursor.latitude), lng: parseFloat(cursor.longitude) },
        });
      });
    }

    // ドラッグ時の処理
    google.maps.event.addListener(map, 'idle', () => {
      refreshLatLng(map);
    });

    // マーカーの移動
    google.maps.event.addListener(map, 'center_changed', () => {
      const pos = map.getCenter();
      marker.setPosition(pos);
    });

    $('.js-map-container').removeClass('loading');
  }

  // 住所から取得ボタン
  $('.js-initialize-map-from-address').on('click', () => {
    let address = $('.js-city-select option:selected').text() + $('.js-address-detail').val();
    address = zen2han(address).split(' ')[0];
    new google.maps.Geocoder().geocode({ address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        map.panTo(results[0].geometry.location);
        refreshLatLng(map);
      }
    });
  });

  initializeMap();
});
